import { Text } from '@/components/Text';
import { Image, View } from 'react-native';
import FontAwesome from '@expo/vector-icons/FontAwesome';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { PatientStackParamList } from '@/navigations/PatientStack';
import { TextLink } from '@/components/TextLink';

interface PromotePageProps {
  onBookingClick: () => void;
}

export const PromotePage = ({ onBookingClick }: PromotePageProps) => {
  const { navigate } =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  return (
    <View className="m-auto flex flex-col items-center justify-center">
      <View className="flex flex-row items-center space-x-6 p-8 w-2/3 shadow-lg">
        <View className="w-1/2 space-y-2">
          <View className="flex flex-row items-center">
            <Image
              source={require('../../assets/appicon/icon-patient.png')}
              style={{ width: 70, height: 70, marginLeft: -8 }}
              resizeMode="contain"
            />
            <Text className="font-bold text-xl"> neolexon Aphasie</Text>
          </View>
          <Text className="text-xl space-x-2">
            <FontAwesome size={18} color="#51bf92" name={'check'} />{' '}
            Individuelle
            <Text>Anpassung durch Therapeut:innen</Text>
          </Text>
          <Text className="text-xl space-x-2">
            <FontAwesome size={18} color="#51bf92" name={'check'} />
            <Text>Unbegrenztes Üben</Text>
          </Text>
          <Text className="text-xl space-x-2">
            <FontAwesome size={18} color="#51bf92" name={'check'} />
            <Text>Interaktive Hilfen</Text>
          </Text>
          <Text className="text-xl space-x-2">
            <FontAwesome size={18} color="#51bf92" name={'check'} /> Keine
            <Text>automatische Verlängerung</Text>
          </Text>
          <Text className="text-xl space-x-2">
            <FontAwesome size={18} color="#51bf92" name={'check'} />
            <Text>
              Nach der Buchung erhalten Sie unsere Rechnung per E-Mail
            </Text>
          </Text>
        </View>
        <View className="w-1/2 space-y-4">
          <PressableNeolexon onPress={onBookingClick}>
            <View className="bg-green-neolexon py-2 px-4 rounded-md">
              <Text className="space-x-4 text-xl">
                <FontAwesome size={18} color="#fff" name={'shopping-cart'} />
                <Text className="text-white font-bold">
                  3 Monate für 223,01 € buchen
                </Text>
              </Text>
            </View>
          </PressableNeolexon>
          <Text className="font-bold">
            Privat Versicherte können eine Kostenübernahme bei ihrer
            Krankenkasse vor der Buchung anfragen. Viele private Krankenkassen
            übernehmen die Kosten für die neolexon Aphasie App. Falls Sie Hilfe
            benötigen, wenden Sie sich telefonisch an uns unter 089 24886 4440.
          </Text>
          <Text className="font-bold">
            Alle Personen, die in Deutschland gesetzlich versichert sind,
            erhalten einen kostenlosen Rezeptcode durch die Krankenkasse und
            lösen diesen{' '}
            <Text
              className="text-blue-800"
              onPress={() => navigate('DigaCodes')}
            >
              hier
            </Text>{' '}
            ein.
          </Text>
        </View>
      </View>
      <View className="space-y-2 mt-8 items-center">
        <Text>
          Sie möchten per Überweisung bezahlen?{' '}
          <TextLink href="https://neolexon.de/wp-content/uploads/2021/05/bestellformular-neolexon-aphasie-patient.pdf">
            Hier klicken
          </TextLink>
          .
        </Text>
        <Text>
          Alle Preisangaben inkl. 19% Mehrwertsteuer, diese kann je nach Land
          variieren.
        </Text>
        <Text>
          Buchung wird durchgeführt durch Chargebee und Stripe. Mehr Infos{' '}
          <TextLink href="https://neolexon.de/datenschutzerklaerung/">
            hier
          </TextLink>
          .
        </Text>
      </View>
    </View>
  );
};
